module.exports = __webpack_public_path__ + "static/EnmTX_BosBigwolf_L_A_cl-2e0d58ca6018b2c414051b8c77af02e3.gif";